// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home"; // Your main page
import DigitalDeclutter from "./pages/DigitalDeclutter"; // folder contains index.jsx
import SleepBlog from "./pages/SleepBlog";
import TwoMinuteReset from "./pages/twoMinutes";
import PrivacyPolicy from "./pages/privacyPolicy";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/digital-declutter" element={<DigitalDeclutter />} />
        <Route path="/Sleep-blog" element={<SleepBlog />} />
        <Route path="/TwoMinutesReset" element={<TwoMinuteReset />} />
  <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  );
}

export default App;
